export const PUBLISHED_AVAILABILITY = 'PUBLISHED_AVAILABILITY';
export const PUBLISHED_FAIR = 'PUBLISHED_FAIR';
